
// Use backend base URL from environment variable
let baseURL = process.env.REACT_APP_BASE_URL_BACKEND;

export { baseURL };